import { render, staticRenderFns } from "./VirtualVisitCall.vue?vue&type=template&id=9dc6021e&scoped=true&"
import script from "./VirtualVisitCall.vue?vue&type=script&lang=js&"
export * from "./VirtualVisitCall.vue?vue&type=script&lang=js&"
import style0 from "./VirtualVisitCall.vue?vue&type=style&index=0&id=9dc6021e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc6021e",
  null
  
)

export default component.exports